// Created mixin to access `this` without binding
export default {
  methods: {
    makeRadioElementsAccessible(refName) {
      const radioRefs = this.$refs[refName]
      radioRefs.map(({ $refs }) => {
        const { input } = $refs

        input.setAttribute('role', 'radio')
      })
    },
  },
}
